import { Box } from '@mui/material';
import CurrencySelect from './CurrencySelect';

/** Selector de moneda de un reporte: no se muestra si el tenant solo tiene pesos. */
export default function ReportCurrencyPicker({ currency, onChange }) {
  return (
    <Box sx={{ minWidth: 200, maxWidth: 260, mb: 2 }}>
      <CurrencySelect label="Moneda del reporte" value={currency} onChange={onChange} />
    </Box>
  );
}
